export class Environment {
    public static readonly Development: string = 'development';
    public static readonly Production: string = 'production';
}